import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ShopProductList from './ShopSearchList';
import MarketInfosContext from '../../../contextProviders/MarketInfosContext';
import { compose } from '../../../services/utilityFunctions';

function ShopSearchContent({ t, query, isLandingPage }) {
  const [count, setCount] = useState(0);

  const { marketInfos } = useContext(MarketInfosContext);

  return (
    <div>
      {!isLandingPage && (
        <div className="row mb-4">
          <div className="col-12">
            <span className="shopQueryResults">
              {count} {t('shop.product.results')}
            </span>
          </div>
        </div>
      )}
      <div className="m-portlet__body m--padding-top-5 m--padding-bottom-20 shop-search-content">
        <div className="row">
          <div className="col-lg-12 shop-search-content-items">
            <ShopProductList
              t={t}
              query={query}
              marketInfos={marketInfos}
              isLandingPage={isLandingPage}
              onCountUpdate={setCount}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

ShopSearchContent.propTypes = {
  t: PropTypes.func.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string.isRequired,
    maxPrice: PropTypes.number.isRequired,
    search: PropTypes.string.isRequired,
    attributes: PropTypes.shape({}).isRequired,
    productType: PropTypes.string,
  }).isRequired,
  isLandingPage: PropTypes.bool,
};

ShopSearchContent.defaultProps = {
  isLandingPage: false,
};

export default React.memo(compose(translate)(ShopSearchContent));
